import {
  Directive,
  ElementRef,
  AfterViewInit,
  OnDestroy,
  Renderer2,
  inject,
} from '@angular/core';

/**
 * Adds a class when the element's content overflows (e.g. scrollHeight > clientHeight).
 * Use to enable vertical scroll only when content exceeds a max-height (e.g. 4 lines).
 */
@Directive({
  selector: '[appOverflowScroll]',
  standalone: true,
})
export class OverflowScrollDirective implements AfterViewInit, OnDestroy {
  private el = inject(ElementRef<HTMLElement>);
  private renderer = inject(Renderer2);
  private resizeObserver: ResizeObserver | null = null;
  private readonly overflowClass = 'overflowing';

  ngAfterViewInit(): void {
    const runCheck = (): void => {
      this.checkOverflow();
    };
    runCheck();
    setTimeout(runCheck, 0);
    this.resizeObserver = new ResizeObserver(runCheck);
    this.resizeObserver.observe(this.el.nativeElement);
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
    this.resizeObserver = null;
  }

  private checkOverflow(): void {
    const host = this.el.nativeElement;
    const overflows = host.scrollHeight > host.clientHeight;
    if (overflows) {
      this.renderer.addClass(host, this.overflowClass);
    } else {
      this.renderer.removeClass(host, this.overflowClass);
    }
  }
}
